// Api returns different versions of the product model (BaseProduct, FBRProduct, DynamicRecsProduct
// etc. Each version has nullable attributes. (like info is null on FBR Product).
// However we merge them in the apollo cache in util.js so that product-pods and child
// calls to useProduct can pull from cache and not create separate api calls.
// The problems with that is when an fbr product is the same as the pip anchor
// product the useProduct hook for the main call is overwritten with the fbr one.
// the only thing this cache does is say if product.dataSources === 'catalog' return it.

export const getProduct = ({ product, domains, dataSource = 'catalog', storeId = '8119' }, cache) => {
  const { itemId } = product || {};
  const dataType = product.dataSources;
  const cachedProducts = cache[itemId];
  if (!cachedProducts) return product;

  if (cachedProducts?.[dataSource]?.[storeId]) return cachedProducts[dataSource][storeId];

  if (cachedProducts?.[product.dataSources]?.[storeId]) return cachedProducts[product.dataSources][storeId];

  // @todo logic to get one with most value on keys

  return product;
};

export const addProduct = ({ product, storeId = '8119' }, cache) => {
  const { itemId } = product || {};
  if (!itemId) return;

  if (!cache[itemId]) {
    cache[itemId] = {};// eslint-disable-line
  }

  cache[itemId][product.dataSources || 'catalog'] = cache[itemId][product.dataSources || 'catalog'] || {};//eslint-disable-line

  cache[itemId][product.dataSources || 'catalog'][storeId] = product;//eslint-disable-line

};
